
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import UcMenuSubComponent from "../main-menu/uc-menu-sub";
import { Route } from "vue-router";

@Component({
  name: "uc-menu-item"
})
export default class UcMenuItemComponent extends Vue {
  @Prop({ type: String })
  title: string;
  @Prop({type: String})
  routeName!: string;
  @Prop({default: () => {}, type: Object})
  params: Object;
  @Prop({ type: String })
  prefix!: string;
  @Prop({ type: String, default: null })
  icon!: string;
  
  isSubMenu = false;
  isShow = false;

  beforeCreate() {
    const defaultSlots = this.$slots.default;
    if (defaultSlots) {
      if (defaultSlots.length > 1) {
        throw new Error(
          "uc-menu-item не может содержать более одного компонента"
        );
      }

      if (!this.GetChildAny("uc-menu-sub")) {
        throw new Error(
          "uc-menu-item внутри может содержать только один компонент menu-sub"
        );
      }
    }
  }

  created() {
  }
  mounted() {
    if (this.isActiveLink() || this.isActiveSubMenu()) {
      this.setSubMenuShow(true);
    }
    if (this.icon && !!(this.$el as HTMLElement).style) {
      var aa = this.$el as HTMLElement;
      aa.style.backgroundImage = this.icon;
    }

    let svgIcon = document.querySelectorAll('.menu-item svg');
    
    for (let i = 0; i < svgIcon.length; i++) {
        svgIcon[i].removeAttribute('width')
        svgIcon[i].removeAttribute('height')
    }
  }
  isActiveLink() {
    if (this.routeName == 'ways/ways-mod') {
    }
    
    return this.$route.name == this.routeName;
  }
  isActiveSubMenu() {
    if (!this.prefix || !this.$route.name) {
      return false;
    }
    return this.$route.name.indexOf(this.prefix) === 0;
  }

  @Watch("$route")
  onRouteChanged() {
    if (this.isActiveLink() || this.isActiveSubMenu()) {
      this.setSubMenuShow(true);
    }
  }

  click(e: any) {
    if (!this.setSubMenuShow()) {
      // location.href = this.url;
      // history.pushState(null, "page 2", this.url);
    } else {
      this.isShow = !this.isShow;
    }
  }

  setSubMenuShow(open: boolean = true) {
    const defaultSlots = this.$children.filter(
      (el) => el instanceof UcMenuSubComponent
    ) as UcMenuSubComponent[];

    if (defaultSlots.length) {
      defaultSlots.forEach((vnode) => {
        vnode.isShow = open;
      });
      return true;
    }
    return false;
  }
}
